import { render, staticRenderFns } from "./detailForm.vue?vue&type=template&id=3bb3a336&scoped=true"
import script from "./detailForm.vue?vue&type=script&lang=js"
export * from "./detailForm.vue?vue&type=script&lang=js"
import style0 from "./detailForm.vue?vue&type=style&index=0&id=3bb3a336&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3bb3a336",
  null
  
)

export default component.exports